import { Store } from '@Globals/Metadata'

const emptyStore: Store = {
  id: '',
  mainStore: '',
  title: '',
}

export default emptyStore
